<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.foodPairing.list")}}</span>
    <div class="searchable-list-container">
      <AveineReferentialList
        :model="model"
        resource="food-pairings"
        entity="food_pairings"
        group-field="category"
        :group-label="$t('intranet.referential.attributes.category')"
        :APIbaseURL="APIbaseURL"
      />
    </div>
  </div>
</template>

<script>
import AveineReferentialList from '@/components/AveineReferentialList.vue'
import FoodPairing from '@/store/models/food-pairing'

export default {
  name: 'Index',
  components: { AveineReferentialList },
  data () {
    return {
      model: FoodPairing,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  }
}
</script>
